import { render } from "./ScoreCarousel.vue?vue&type=template&id=0565891c&ts=true"
import script from "./ScoreCarousel.vue?vue&type=script&lang=ts"
export * from "./ScoreCarousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__